import React from 'react';
import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import './MobileProgressBar.scss';

const useStyles = makeStyles({
  mobileProgressBar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0',
    alignItems: 'center'
  },
  progressBarContainer: {
    width: '100%',
    padding: '0.25rem 0'
  },
  progressBar: {
    height: '0.6rem',
    backgroundColor: '#e0e0e0'
  },
  progressPercent: {
    paddingLeft: '0.5rem',
    fontSize: '1rem'
  }
});

export const MobileProgressBar = props => {
  const classes = useStyles();
  const { progress } = props;
  return (
    <React.Fragment>
      <div className={classes.mobileProgressBar}>
        <div className={classes.progressBarContainer}>
          <LinearProgress className={classes.progressBar} ecolor="secondary" variant="determinate" value={progress} />
        </div>
        <span className={classes.progressPercent}>{`${progress}%`}</span>
      </div>
    </React.Fragment>
  );
};
